var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wow",
    transform: "translate(-4610.822 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4610.822 2167.377)",
    fill: "#f7db83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 4.696,
    cy: 7.097,
    rx: 4.696,
    ry: 7.097,
    transform: "translate(4624.271 2186.113)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M4622.752,2181.254c0,1.913-1.026,3.464-2.293,3.464s-2.292-1.551-2.292-3.464,1.026-3.465,2.292-3.465S4622.752,2179.34,4622.752,2181.254Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M4639.767,2181.254c0,1.913-1.026,3.464-2.292,3.464s-2.293-1.551-2.293-3.464,1.027-3.465,2.293-3.465S4639.767,2179.34,4639.767,2181.254Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M4623.355,2174.27a.709.709,0,0,1-.5-.208,2.923,2.923,0,0,0-4.036,0,.712.712,0,0,1-1.007-1.008,4.278,4.278,0,0,1,6.05,0,.712.712,0,0,1-.5,1.216Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M4639.36,2174.27a.709.709,0,0,1-.5-.208,2.923,2.923,0,0,0-4.036,0,.712.712,0,0,1-1.007-1.008,4.278,4.278,0,0,1,6.05,0,.712.712,0,0,1-.5,1.216Z",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.180f1e93c4c61f361b8a14aa7a324532.svg";
export { ForwardRef as ReactComponent };